import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Todo } from '../../models/todo';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TodoService {
  private apiUrl = environment.apiUrl;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient
  ) {}

  getAll(): Observable<Todo[]> {
    return this.http.get<Todo[]>(`${this.apiUrl}/todos`);
  }

  editOne(todo: Todo): Observable<Todo> {
    return this.http.patch<Todo>(`${this.apiUrl}/todos/${todo.id}`, todo, { headers: this.headers  });
  }

  deleteOne(todo: Todo): Observable<Todo> {
    return this.http.delete<Todo>(`${this.apiUrl}/todos/${todo.id}`, { headers: this.headers  });
  }

  createOne(todo: Todo): Observable<Todo> {
    return this.http.post<Todo>(`${this.apiUrl}/todos`, todo, { headers: this.headers  });
  }
}
